export default __webpack_public_path__ + "locales/az/Errors.json?hash=5974280f92dc3bb463d8872d370dd05d";